export default __webpack_public_path__ + "static/media/04.524f273f.png";